import React, { useEffect, useState } from 'react'
import { Box, Text, Flex, Avatar, Button } from '@chakra-ui/react'
import { ChevronDownIcon } from '@chakra-ui/icons'
import getAvatar from 'components/BankAccordion/bankAvatar'
import { IDashboardBanks } from 'services/IApi.d'


interface IBanksAdditionalProps {
  banks: IDashboardBanks[]
}

// Bancos Subscription Resume
const BanksAdditional = ({ banks }: IBanksAdditionalProps) => {

  const minBanks = 3
  const [expanded, setExpanded] = useState<boolean>(false);
  const [countBanks, setCountBanks] = useState<number>(minBanks);

  useEffect(() => {
     (expanded) ?  setCountBanks(banks.length) :    setCountBanks(3)
  }, [expanded]);

    
return (  
  <Box
    data-testid='banks'
    maxW={520}
    overflow='auto'
  >
    {banks.slice(0,countBanks).map(({ name }, indexBank) => (
      <Flex
        data-testid = {`bank-${indexBank}`}
        key={name}
        alignItems='center'
        pb='8px'
        pl='12px'
        gap='6px'
      >
        <Avatar data-testid={`bank-avatar-${name}`} name={name} src={getAvatar(name)} size='sm' />
        <Text data-testid={`bank-name-${name}`} ml={2} textStyle='titleMd' fontWeight='500' size='xs' line-height='2xm' color='secondary.700'>{name}</Text>
      </Flex>

    ))}

    {banks.length > minBanks &&
      <Box data-testid='bank-expand' flex={1} alignItems={'center'} textAlign={'center'}>
        <Button data-testid='bank-expand-buttom'  variant='primary-text' size={'md'} onClick={()=>setExpanded(!expanded)} rightIcon={<ChevronDownIcon boxSize={'20px'}/>}>
          {expanded ? 'Ver menos': 'Ver más'}
          </Button>
      </Box>
    }
  </Box>
)
}

export default BanksAdditional